import { render, staticRenderFns } from "./AvisosList.vue?vue&type=template&id=48e2c46a&scoped=true"
import script from "./AvisosList.vue?vue&type=script&lang=js"
export * from "./AvisosList.vue?vue&type=script&lang=js"
import style0 from "./AvisosList.vue?vue&type=style&index=0&id=48e2c46a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2c46a",
  null
  
)

export default component.exports